module.exports = __webpack_public_path__ + "img/info-air-quality.11044f08.svg";